<template>
  <home-card
    :icon="icon"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-slot:after-heading>
      <div class="ml-auto text-right">
        <v-chip
          close
          color="transparent"
          class="mr-n1"
          :close-icon="hidden ? 'mdi mdi-eye' : 'mdi mdi-eye-off'"
          @click:close="hideSum"
        >{{ title }}</v-chip>
        <h3 class="display-1 font-weight-light text--primary">
          <count-up
            v-if="!hidden"
            class="font-weight-bold"
            :end-val="value * 1"
            :options="counterUpOptions"
          ></count-up>
          <span v-else class="font-weight-bold">{{ value.toFixed(decimalPlaces).replace(/./g, '*') }}</span>
          <small>{{ unit }}</small>
        </h3>
      </div>
    </template>

    <v-col cols="12" class="px-0">
      <v-divider></v-divider>
    </v-col>

    <v-card-actions class="pa-0">
      <v-icon size="16" class="mr-1">{{ subIcon }}</v-icon>

      <span class="caption grey--text font-weight-light" v-text="subText"></span>

      <v-spacer></v-spacer>

      <v-btn
        small
        outlined
        class="my-n2"
        :to="path"
        :color="$attrs.color"
      >图表分析</v-btn>
    </v-card-actions>
  </home-card>
</template>

<script>
  import CountUp from 'vue-countup-v2'
  import HomeCard from './HomeCard'

  export default {
    name: 'home-stats-card',
    components: {HomeCard, CountUp},
    props: {
      sum: {
        type: String,
      },
      title: {
        type: String,
        default: undefined,
      },
      path: {
        type: String,
        default: undefined,
      },
      value: {
        type: [String, Number],
        default: undefined,
      },
      unit: {
        type: [String, Number],
        default: undefined,
      },
      decimalPlaces: {
        type: [String, Number],
        default: 0,
      },
      icon: {
        type: String,
        required: true,
      },
      subIcon: {
        type: String,
        default: undefined,
      },
      subText: {
        type: String,
        default: undefined,
      },
      hidden: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      counterUpOptions () {
        return {
          decimalPlaces: this.decimalPlaces,
          separator: ''
        }
      }
    },
    methods: {
      hideSum () {
        const hiddenSums = JSON.parse(localStorage.getItem('hidden_sums') || '[]')

        if (this.hidden) {
          hiddenSums.splice(hiddenSums.indexOf(this.sum), 1)
        } else {
          hiddenSums.push(this.sum)
        }

        localStorage.setItem('hidden_sums', JSON.stringify(hiddenSums))

        this.$emit('update:hidden', !this.hidden)
      }
    }
  }
</script>
